// cabang.repo — master Cabang (outlets). Port OUTLETS/outletForm v0.18.
import { supabase } from '@core/supabase';
import type { Outlet } from '@core/types';

const SEL = 'kode,nama,kota,telp,wa,alamat,rekening,gmaps,gembok';

export async function listCabang(): Promise<Outlet[]> {
  const { data, error } = await supabase().from('outlets').select(SEL).order('kode');
  if (error) throw new Error(error.message);
  return (data ?? []) as Outlet[];
}
export async function createCabang(d: Record<string, unknown>): Promise<void> {
  const { error } = await supabase().from('outlets').insert(d);
  if (error) throw new Error(error.code === '23505' ? 'Kode cabang sudah dipakai.' : error.message);
}
export async function updateCabang(kode: string, d: Record<string, unknown>): Promise<void> {
  const { error } = await supabase().from('outlets').update(d).eq('kode', kode); if (error) throw new Error(error.message);
}
export async function removeCabang(kode: string): Promise<void> {
  const { error } = await supabase().from('outlets').delete().eq('kode', kode); if (error) throw new Error(error.message);
}
export async function ticketCount(kode: string): Promise<number> {
  const { count, error } = await supabase().from('tickets').select('no', { count: 'exact', head: true }).eq('outlet', kode);
  if (error) throw new Error(error.message);
  return count ?? 0;
}
export async function employeeCount(kode: string): Promise<number> {
  const { count, error } = await supabase().from('employees').select('id', { count: 'exact', head: true }).eq('outlet', kode);
  if (error) throw new Error(error.message);
  return count ?? 0;
}
export async function customerCount(kode: string): Promise<number> {
  const { count, error } = await supabase().from('customers').select('id', { count: 'exact', head: true }).eq('outlet', kode);
  if (error) throw new Error(error.message);
  return count ?? 0;
}
export async function overrideCount(kode: string): Promise<number> {
  const { count, error } = await supabase().from('service_overrides').select('service_id', { count: 'exact', head: true }).eq('outlet', kode);
  if (error) throw new Error(error.message);
  return count ?? 0;
}

export interface EmpBrief { nama: string; role: string; outlet: string | null }
/** Ringkas karyawan (utk kolom staffing + dialog anggota read-only di master Cabang). RLS: O/M lihat semua. */
export async function listEmployeesBrief(): Promise<EmpBrief[]> {
  const { data, error } = await supabase().from('employees').select('nama,role,outlet').eq('aktif', true).order('nama');
  if (error) throw new Error(error.message);
  return (data ?? []) as EmpBrief[];
}
